/* import __COLOCATED_TEMPLATE__ from './cancel-link.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
